var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "t-dropdown",
    { attrs: { buttonTagName: "button" } },
    [
      _c("template", { slot: "button-content" }, [_vm._t("button-content")], 2),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }